const PlainText = ({ value, children = value || '-', style, className }) => (
  <strong className={className} style={style} dangerouslySetInnerHTML={{ __html: children }} />
)

export default (hoc) => hoc(PlainText)
